(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mw-wall-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('mw-gallery')) return;
  const cards = () => [...document.querySelectorAll('mw-gallery [data-wall]')];
  const syncLayout = () => {
    document.querySelectorAll('.mw-gallery-page').forEach(root => {
      if (!root.querySelector('mw-gallery')) root.classList.remove('mw-gallery-page');
    });
    const roots = new Set();
    document.querySelectorAll('mw-gallery').forEach(gallery => {
      const section = gallery.closest('.shopify-section');
      if (!section) return;
      section.classList.add('mw-gallery-section');
      roots.add(section.parentElement);
    });
    roots.forEach(root => {
      const gallery = root.querySelector('mw-gallery');
      const style = getComputedStyle(gallery);
      root.classList.add('mw-gallery-page');
      root.style.setProperty('--mw-gallery-columns', style.getPropertyValue('--mw-columns').trim() || '2');
      root.style.setProperty('--mw-gallery-background', style.getPropertyValue('--mw-background').trim() || '#fff');
    });
  };
  const rebuildFilters = () => {
    syncLayout();
    document.querySelectorAll('[data-mw-filters]').forEach(root => {
      const active = root.querySelector('[aria-pressed="true"]')?.dataset.room || '';
      const rooms = [...new Set(cards().map(c => c.dataset.room).filter(Boolean))];
      root.replaceChildren();
      ['', ...rooms].forEach(room => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.room = room;
        button.textContent = room || root.dataset.all;
        button.setAttribute('aria-pressed', String(room === active));
        button.addEventListener('click', () => {
          root.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          cards().forEach(c => { c.hidden = Boolean(room && c.dataset.room !== room); });
          document.querySelectorAll('mw-gallery').forEach(g => {g.hidden = !g.querySelector('[data-wall]:not([hidden])');});
          document.querySelectorAll('[data-mw-count]').forEach(n => {n.textContent = cards().filter(c => !c.hidden).length;});
        });
        root.append(button);
      });
      (root.querySelector('[aria-pressed="true"]') || root.firstElementChild)?.click();
    });
  };
  class WallGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.words = JSON.parse(this.querySelector('[data-mw-words]').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale || 'sv-SE', {style:'currency',currency:this.dataset.currency || 'SEK',minimumFractionDigits:0});
      this.querySelectorAll('[data-wall]').forEach(card => {
        const dialog = card.querySelector('dialog');
        const open = card.querySelector('[data-open]');
        open.addEventListener('click', () => this.open(dialog, open), options);
        dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', e => {if(e.target === dialog){ const r=dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}}, options);
        dialog.addEventListener('close', () => {document.documentElement.style.overflow = this.previousOverflow || '';this.opener?.focus({preventScroll:true});}, options);
        dialog.addEventListener('change', e => {
          if (e.target.matches('[data-frames]')) {
            dialog.querySelectorAll('[data-poster]').forEach(p => {
              const selected = p.querySelector('[data-kind="poster"] [data-pick]').checked;
              const frame = p.querySelector('[data-kind="frame"] [data-pick]');
              if(frame && !frame.disabled) frame.checked = selected && e.target.checked;
            });
          }
          if(e.target.closest('[data-kind="poster"]')) {
            const poster=e.target.closest('[data-poster]'); const frame=poster.querySelector('[data-kind="frame"] [data-pick]');
            if(frame && !frame.disabled) frame.checked=e.target.checked && dialog.querySelector('[data-frames]').checked;
          }
          this.update(dialog);
        }, options);
        dialog.querySelector('form').addEventListener('submit', e => {e.preventDefault();this.add(dialog);}, options);
        this.update(dialog);
      });
      document.addEventListener('shopify:block:select', e => {const card=e.target.closest('[data-wall]');if(card && this.contains(card))this.open(card.querySelector('dialog'),card.querySelector('[data-open]'));}, options);
      queueMicrotask(rebuildFilters);
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(d=>d.close());
      this.controller?.abort();this.controller=null;queueMicrotask(rebuildFilters);
    }
    open(dialog, opener) {
      if(dialog.open)return;
      this.opener=opener;this.previousOverflow=document.documentElement.style.overflow;
      this.update(dialog);dialog.showModal();document.documentElement.style.overflow='hidden';
      dialog.querySelector('[data-close]').focus({preventScroll:true});
    }
    selected(dialog) {
      const posterCount=[...dialog.querySelectorAll('[data-kind="poster"]')].reduce((n,row)=>n+(row.querySelector('[data-pick]').checked?Number(row.dataset.quantity):0),0);
      return [...dialog.querySelectorAll('[data-item]')].flatMap(row=>{
        const check=row.querySelector('[data-pick]');
        const parent=row.closest('[data-poster]');
        if(row.dataset.kind==='frame' && !parent.querySelector('[data-kind="poster"] [data-pick]').checked)return [];
        let quantity=Number(row.dataset.quantity);
        if(row.dataset.mode==='per_poster') quantity=Math.ceil(posterCount*quantity/Number(row.dataset.pack));
        if(!check.checked || check.disabled || !row.dataset.variant || quantity<1)return [];
        return [{row,id:Number(row.dataset.variant),quantity,price:Number(row.dataset.price)}];
      });
    }
    update(dialog) {
      const selected=this.selected(dialog);
      const total=selected.reduce((n,item)=>n+item.quantity*item.price,0);
      dialog.querySelector('[data-total]').textContent=this.money.format(total/100);
      dialog.querySelector('[data-count]').textContent=`${selected.reduce((n,item)=>n+item.quantity,0)} ${this.words.items}`;
      const posters=selected.filter(item=>item.row.dataset.kind==='poster');
      const button=dialog.querySelector('[data-add]');
      dialog.querySelector('[data-empty]').hidden=posters.length>0;
      button.disabled=!posters.length || dialog.dataset.busy==='true' || dialog.dataset.uncertain==='true';
      dialog.querySelectorAll('[data-kind="accessory"]').forEach(row=>{
        const q=row.dataset.mode==='per_poster'?Math.ceil(posters.reduce((n,i)=>n+i.quantity,0)*Number(row.dataset.quantity)/Number(row.dataset.pack)):Number(row.dataset.quantity);
        row.querySelector('.mw-item__price').textContent=`${q} × ${this.money.format(Number(row.dataset.price)/100)}`;
      });
      const eligible=[...dialog.querySelectorAll('[data-poster]')].filter(p=>p.querySelector('[data-kind="poster"] [data-pick]').checked);
      const frames=eligible.flatMap(p=>[...p.querySelectorAll('[data-kind="frame"] [data-pick]')]).filter(c=>!c.disabled);
      const toggle=dialog.querySelector('[data-frames]');
      toggle.indeterminate=frames.some(c=>c.checked)&&!frames.every(c=>c.checked);
      toggle.checked=frames.length>0&&frames.every(c=>c.checked);
      dialog.querySelector('[data-frame-warning]').hidden=!eligible.some(p=>!p.querySelector('[data-kind="frame"] [data-pick]')||p.querySelector('[data-kind="frame"] [data-pick]').disabled);
    }
    async add(dialog) {
      if(dialog.dataset.busy==='true'||dialog.dataset.uncertain==='true')return;
      const selected=this.selected(dialog);
      if(!selected.some(i=>i.row.dataset.kind==='poster'))return;
      const status=dialog.querySelector('[data-status]');
      if(window.Shopify?.designMode){status.textContent=this.words.preview;return;}
      const merged=new Map();
      for(const item of selected){if(!Number.isSafeInteger(item.id)||!Number.isInteger(item.quantity)||item.quantity<1){status.textContent=this.words.invalid_quantity;return;}const current=merged.get(item.id);if(current)current.quantity+=item.quantity;else merged.set(item.id,{id:item.id,quantity:item.quantity,properties:{_Tavelvägg:dialog.dataset.wallTitle}});}
      dialog.dataset.busy='true';
      const button=dialog.querySelector('[data-add]');button.textContent=this.words.adding;status.textContent='';
      dialog.querySelectorAll('input').forEach(i=>{i.dataset.wasDisabled=String(i.disabled);i.disabled=true;});
      button.disabled=true;
      try {
        const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...merged.values()]}),credentials:'same-origin'});
        const result=await response.json();
        if(!response.ok){status.textContent=(typeof result.description==='string'?result.description:this.words.stock_changed);dialog.dataset.uncertain='true';dialog.querySelector('[data-cart-link]').hidden=false;return;}
        status.textContent=this.words.added;
        dialog.dataset.uncertain='true';
        dialog.querySelector('[data-cart-link]').hidden=false;
        window.location.assign(this.dataset.cartUrl);
      } catch(error) {
        status.textContent=this.words.uncertain;dialog.dataset.uncertain='true';dialog.querySelector('[data-cart-link]').hidden=false;
      } finally {
        dialog.dataset.busy='false';button.textContent=this.words.add;
        dialog.querySelectorAll('input').forEach(i=>{i.disabled=i.dataset.wasDisabled==='true';delete i.dataset.wasDisabled;});
        this.update(dialog);
      }
    }
  }
  customElements.define('mw-gallery', WallGallery);
  document.addEventListener('shopify:section:load', rebuildFilters);
  document.addEventListener('shopify:section:reorder', rebuildFilters);
  document.addEventListener('DOMContentLoaded', rebuildFilters, {once:true});
})();


  } catch(e) { console.error(e); }
})();
})();
